enum WorkOrderStatusEnum {
  AwaitingAllocation = "Awaiting Allocation",
  Allocated = "Allocated",
  Collected = "Collected",
  Disposing = "Disposing",
  Disposed = "Disposed",
  Abandoned = "Abandoned",
  TempDropped = "Temp Dropped"
}

const WorkOrderEndOfLifeStatusesProvider = [WorkOrderStatusEnum.Abandoned, WorkOrderStatusEnum.Collected];
const WorkOrderEndOfLifeStatusesVehicle = [WorkOrderStatusEnum.Abandoned, WorkOrderStatusEnum.Disposed];

const AllowedAllocateToStatuses = [WorkOrderStatusEnum.Allocated, WorkOrderStatusEnum.TempDropped];
const AllowedToCompleteStatuses = [WorkOrderStatusEnum.Allocated];

export {
  WorkOrderStatusEnum, WorkOrderEndOfLifeStatusesProvider, WorkOrderEndOfLifeStatusesVehicle, AllowedAllocateToStatuses, AllowedToCompleteStatuses
};
